import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { PaymentWallets } from '@root/features/wallet/payment-wallets/ui/payment-wallets'
import { useTranslation } from '@root/shared/localization'
import { Separator } from '@root/shared/ui-kit'

import { PaymentDialogFormFields } from '../desktop/common/payment-dialog-form-fields'

import { PaymentFormAction } from './payment-form-action'

import type { DeviceType } from '@blade/ui-kit'
import type { CurrencyModel } from '@root/entities/currency'
import type { PurchaseBoostersReatom } from '@root/features/premium/purchase-boosters'

const QUICK_OPTIONS = [20, 50, 100, 150, 200]

type Props = {
  currency: CurrencyModel
  model: PurchaseBoostersReatom
  device: DeviceType
}

export const BuyBoostersForm: React.FC<Props> = ({ model, device }) => {
  const { t } = useTranslation()

  const [paymentSource, setPaymentSource] = useAtom(model.paymentSourceAtom)

  const purchase = useAction(model.purchaseBoostersAction)

  return (
    <Root
      noValidate
      onSubmit={(e) => {
        e.preventDefault()
        purchase()
      }}
    >
      <Separator />
      <Note>{t('premium.pay.boosters.note')}</Note>
      <PaymentDialogFormFields
        type="boosters"
        model={model}
        quickOptions={QUICK_OPTIONS}
      />
      <Separator />
      <PaymentWallets
        label={t('premium.pay.wallets.title')}
        device={device}
        paymentSource={paymentSource}
        setPaymentSource={setPaymentSource}
      />
      <PaymentFormAction product="boosters" model={model} />
    </Root>
  )
}

const Root = styled.form`
  display: grid;
  gap: 16px;
`

const Note = styled.p`
  color: var(--text-7);

  text-align: center;
  justify-self: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
`
